<!-- <h1 class="text-center"> MI APLICACION DE PRUEBA</h1>
<div class="col-lg-12">
  <div class="row">
    <div class="col-lg-4" style="background: yellow;">
      <app-menu></app-menu>
    </div>
    <div class="col-lg-8">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->
<!-- <app-loading></app-loading> -->
<router-outlet></router-outlet>